export default __webpack_public_path__ + "static/media/info-icon.f61fd726.svg";